import axios from "axios";
import store from "store/store";

export default function(endpoint, method, params, auth) {
    return new Promise(function(resolve, reject){

        axios({
            baseURL         : store.getState().config.api_url + endpoint
            ,method         : method
            ,params         : method == 'get' ? params : {}
            ,data           : ['post', 'delete', 'puth'].indexOf(method) > -1 ? params : {}
            ,maxRedirects   : 2
            ,headers        : {
                Authorization : auth ? auth : store.getState().config.auth.basic
            }
            ,transformResponse : [(data) => {
                return JSON.parse(data);
            }]
        })
        
            .then(function(response){

                if(response.status == 200)
                {
                    resolve(response.data);
                }
                else
                {
                    reject('');
                }
                

            })
            .catch(function(error){
                if(typeof error.response.data.message != 'undefined')
                {
                    reject(error.response.data.message);
                }
                else
                {
                    reject('Something wrong communicating with services');
                }
            })
                            
    });
}